import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Alert, notification, Switch, Table, Space, Modal, InputNumber } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'

import "./style.scss";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;

const TopUpTeamLeaders = ({ userStore  }) => {

    const [form] = Form.useForm();
    const [formEdit] = Form.useForm();
    const navigate = useNavigate();

    // GET ALL USERS BY USERTYPE
    const userType = "TEAM_LEADER";

    // FOR SEARCHING OF TEAM LEADER NAME
    const [searchName, setSearchName] = useState();

    // FOR SELECTED TEAM LEADER AND TOP UP DATA
    const [selectedTeamLeader, setSelectedTeamLeader] = useState()
    const [topUpCashTeamLeaders, setTopUpCashTeamLeaders] = useState([])
    const [topUpItemTeamLeaders, setTopUpItemTeamLeaders] = useState([])

    //FOR MODAL
    const [isOpenForm, setIsOpenForm] = useState(false)
    const [isOpenEditFormCash, setIsOpenEditFormCash] = useState(false)
    const [isOpenEditFormItem, setIsOpenEditFormItem] = useState(false)

    // FOR TOTAL AMOUNT
    const [total, setTotal] = useState(0)
    const [totalCash , setTotalCash] = useState(0)
    const [totalItems , setTotalItems] = useState(0)

    //FOR CONDITION OF DISTRIBUTION IF ITEM OR CASH
    const [distributionType, setDistributionType] = useState();

    useEffect(() => {
        const storedDataCash = JSON.parse(localStorage.getItem("topUpCashTeamLeaders")) || [];
        const storedDataItem = JSON.parse(localStorage.getItem("topUpItemTeamLeaders")) || [];

        const newTotalCash = storedDataCash.reduce((sum, item) => sum + parseInt(item.amount), 0);
        setTotalCash(newTotalCash);

        const newTotalItem = storedDataItem.reduce((sum, item) => sum + parseInt(item.amount), 0);
        setTotalItems(newTotalItem);
    }, [])
    
    useEffect(() => {
        // INCASE THE USER REFRESH IT WILL CALL THE DATA FROM THE LOCALSTORAGE
        const storedDataCash = JSON.parse(localStorage.getItem("topUpCashTeamLeaders")) || [];
        setTopUpCashTeamLeaders(storedDataCash);

        const storedDataItem = JSON.parse(localStorage.getItem("topUpItemTeamLeaders")) || [];
        setTopUpItemTeamLeaders(storedDataItem);

        if(selectedTeamLeader) {
            form.setFieldsValue(selectedTeamLeader)
        }
    }, [selectedTeamLeader])

    useEffect(() => {
        userStore.page = 1;
        userStore.hasMore = false;
        userStore.perPage = 5;
        userStore.fetchUsersTeamLeaders(userType);
    }, []);

    const formatNumber = (formatnumber) => {
        return new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(formatnumber);
    };

    const columns = [
        {
          title: 'Name',
          key: 'FullName+ID',
          dataIndex: 'FullName',
          responsive: ['lg', 'xl', 'md'],
          render: (FullName) => (
            <Text default>{FullName}</Text>
          )
        },
        {
          title: 'Contact Number',
          key: 'ContactNumber+ID',
          dataIndex: 'ContactNumber',
          responsive: ['lg', 'xl', 'md'],
          render: (ContactNumber) => (
            <Text default>{ContactNumber}</Text>
          )
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost
                    onClick={() => {
                        setSelectedTeamLeader(null); // Reset before selecting
                        setDistributionType(null); // Reset before selecting
                        form.resetFields(); // Reset form fields
                    
                        setSelectedTeamLeader(record);
                        setIsOpenForm(true);
                    }}
                >Select</Button>
            </Space>
          )
        },
    ];

    const columnsTopUpCash = [
        {
          title: 'Name',
          key: 'FullName',
          dataIndex: 'FullName',
          responsive: ['lg', 'xl', 'md'],
          render: (FullName) => (
            <Text default>{FullName}</Text>
          )
        },
        {
            title: 'Total Amount',
            key: 'amount',
            dataIndex: 'amount',
            responsive: ['lg', 'xl', 'md'],
            render: (amount) => (
              <Text default>₱ {formatNumber(amount)}</Text>
            )
          },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost 
                    onClick={() => {
                        formEdit.setFieldsValue(record)
                        setSelectedTeamLeader(record)
                        setIsOpenEditFormCash(true)
                    }}
                >Edit</Button>
                <Modal 
                    title="Edit Cash Amount" 
                    open={isOpenEditFormCash} 
                    onOk={() => {
                        formEdit.submit()
                        setIsOpenEditFormCash(false)
                    }}
                    onCancel={() => setIsOpenEditFormCash(false)}
                >
                    <Form
                        name="addbillingInformationForm"
                        layout="vertical"
                        form={formEdit} 
                        onFinish={onFinishEditCash}
                    >
                        <Form.Item 
                            label="Top up Amount" 
                            name="amount"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input Amount.',
                                },
                            ]}
                        >
                            <InputNumber placeholder="Enter Amount" style={{width: "100%"}}/>
                        </Form.Item>
                    </Form>
                </Modal>
                <Button type="primary" ghost danger onClick={() => handleDeleteCash(record.id)}>Delete</Button>
            </Space>
          )
        },
    ];

    const columnsTopUpItems = [
        
        {
          title: 'Name',
          key: 'FullName',
          dataIndex: 'FullName',
          responsive: ['lg', 'xl', 'md'],
          render: (FullName) => (
            <Text default>{FullName}</Text>
          )
        },
        {
            title: 'Item',
            key: 'itemName',
            dataIndex: 'itemName',
            responsive: ['lg', 'xl', 'md'],
            render: (itemName) => (
              <Text default>{itemName}</Text>
            )
        },
        {
            title: 'Price per Unit',
            key: 'pricePerUnit',
            dataIndex: 'pricePerUnit',
            responsive: ['lg', 'xl', 'md'],
            render: (pricePerUnit) => (
                <Text default>₱ {formatNumber(pricePerUnit)}</Text>
            )
        },
        {
            title: 'Quantity',
            key: 'quantity',
            dataIndex: 'quantity',
            responsive: ['lg', 'xl', 'md'],
            render: (quantity) => (
              <Text default>{quantity}</Text>
            )
        },
        {
            title: 'Total Amount',
            key: 'amount',
            dataIndex: 'amount',
            responsive: ['lg', 'xl', 'md'],
            render: (amount) => (
              <Text default>₱ {formatNumber(amount)}</Text>
            )
          },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost 
                    onClick={() => {
                        formEdit.setFieldsValue(record)
                        setSelectedTeamLeader(record)
                        setIsOpenEditFormItem(true)
                    }}
                >Edit</Button>
                <Modal 
                    title="Edit Edit Item Details" 
                    open={isOpenEditFormItem} 
                    onOk={() => {
                        formEdit.submit()
                        setIsOpenEditFormItem(false)
                    }}
                    onCancel={() => setIsOpenEditFormItem(false)}
                >
                    <Form
                        name="addbillingInformationForm"
                        layout="vertical"
                        form={formEdit} 
                        onFinish={onFinishEditItem}
                        onValuesChange={(changedValues, allValues) => {
                            const { pricePerUnit, quantity } = allValues;
                            if (pricePerUnit && quantity) {
                                const amount = pricePerUnit * quantity;
                                formEdit.setFieldsValue({ amount });
                            }
                        }}
                    >
                        <Form.Item 
                            label="Item Name" 
                            name="itemName"
                            rules={[{ required: true, message: 'Please input Item Name.' }]}
                        >
                            <Input placeholder="Enter Item Name" />
                        </Form.Item>
                        <Form.Item 
                            label="Description" 
                            name="description"
                            rules={[{ required: true, message: 'Please input the description.' }]}
                        >
                            <Input placeholder="Enter Description" />
                        </Form.Item>
                        <Form.Item 
                            label="Price per Unit" 
                            name="pricePerUnit"
                            rules={[{ required: true, message: 'Please input the price per unit.' }]}
                        >
                            <InputNumber placeholder="Enter Price" style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item 
                            label="Quantity" 
                            name="quantity"
                            rules={[{ required: true, message: 'Please input the quantity.' }]}
                        >
                            <InputNumber placeholder="Enter Quantity" style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item 
                            label="Amount" 
                            name="amount"
                            rules={[{ required: true, message: 'Please input the amount.' }]}
                        >
                            <InputNumber placeholder="Enter Amount" style={{ width: "100%" }} />
                        </Form.Item>
                    </Form>
                </Modal>
                <Button type="primary" ghost danger onClick={() => handleDeleteItem(record.id)}>Delete</Button>
            </Space>
          )
        },
    ];

    const onFinish = (values) => {
        const storedCashData = JSON.parse(localStorage.getItem("topUpCashTeamLeaders")) || [];
        const storedItemData = JSON.parse(localStorage.getItem("topUpItemTeamLeaders")) || [];
    
        const newEntry = { id: Date.now(), ...selectedTeamLeader, ...values };
    
        if (distributionType === "cash") {

            var total = 0;
            
            // Prevent duplicate entry
            if (storedCashData.some(item => item.UserID === newEntry.UserID)) {
                notification.warning({
                    message: "Warning!",
                    description: `${newEntry.FullName} is already in the cash top-up list.`,
                    top: 120,
                });
                return;
            }
    
            const updatedCashList = [...storedCashData, newEntry];
            setTopUpCashTeamLeaders(updatedCashList);
            localStorage.setItem("topUpCashTeamLeaders", JSON.stringify(updatedCashList));

            // Update total cash amount
            const newTotalCash = updatedCashList.reduce((sum, item) => sum + parseInt(item.amount), 0);
            setTotalCash(newTotalCash);
        } else if (distributionType === "item") {
            // Prevent duplicate entry
            // if (storedItemData.some(item => item.UserID === newEntry.UserID)) {
            //     notification.warning({
            //         message: "Warning!",
            //         description: `${newEntry.FullName} is already in the item top-up list.`,
            //         top: 120,
            //     });
            //     return;
            // }
    
            const updatedItemList = [...storedItemData, newEntry];
            setTopUpItemTeamLeaders(updatedItemList);
            localStorage.setItem("topUpItemTeamLeaders", JSON.stringify(updatedItemList));

            // Update total item amount
            const newTotalItems = updatedItemList.reduce((sum, item) => sum + parseInt(item.amount), 0);
            setTotalItems(newTotalItems);
        }
    
        form.resetFields();
    };

    const onFinishEditCash = (values) => {
        const storedData = JSON.parse(localStorage.getItem(`topUpCashTeamLeaders`)) || [];

        // Find the previous data
        const previousData = storedData.find(item => item.id === selectedTeamLeader.id);
        const previousAmount = previousData ? parseInt(previousData.amount) : 0; // Handle cases where data doesn't exist

        // Update the voter’s data with new values
        const updatedList = storedData.map(item =>
            item.id === selectedTeamLeader.id
                ? { ...item, ...values } 
                : item 
        );
    
        setTopUpCashTeamLeaders(updatedList);

        var total = 0;

        // Calculate the new total, but subtract the previous amount first
        storedData.forEach((topUpTeamLeader) => {
            total += parseInt(topUpTeamLeader.amount);
        });
        
        // Update the total correctly
        setTotalCash(total - previousAmount + parseInt(values.amount)); 

        // Save updated data to localStorage
        localStorage.setItem(`topUpCashTeamLeaders`, JSON.stringify(updatedList));
    
        formEdit.resetFields();
        setIsOpenEditFormCash(false); 
    };

    const onFinishEditItem = (values) => {
        const storedData = JSON.parse(localStorage.getItem(`topUpItemTeamLeaders`)) || [];

        // Find the previous data
        const previousData = storedData.find(item => item.id === selectedTeamLeader.id);
        const previousAmount = previousData ? parseInt(previousData.amount) : 0; // Handle cases where data doesn't exist

        // Update the voter’s data with new values
        const updatedList = storedData.map(item =>
            item.id === selectedTeamLeader.id
                ? { ...item, ...values } 
                : item 
        );
    
        setTopUpItemTeamLeaders(updatedList);

        var total = 0;

        // Calculate the new total, but subtract the previous amount first
        storedData.forEach((topUpTeamLeader) => {
            total += parseInt(topUpTeamLeader.amount);
        });
        
        // Update the total correctly
        setTotalItems(total - previousAmount + parseInt(values.amount)); 

        // Save updated data to localStorage
        localStorage.setItem(`topUpItemTeamLeaders`, JSON.stringify(updatedList));
    
        formEdit.resetFields();
        setIsOpenEditFormItem(false); 
    };

    const handleDeleteCash = (teamLeaderID) => {
        const storedData = JSON.parse(localStorage.getItem(`topUpCashTeamLeaders`)) || [];

        // Filter out the voter to delete
        const updatedList = storedData.filter(item => item.id !== teamLeaderID);

        // Update the total amount
        const newTotal = updatedList.reduce((sum, item) => sum + parseInt(item.amount), 0);

        // Update state
        setTopUpCashTeamLeaders(updatedList);
        setTotalCash(newTotal);

        // Save updated list back to local storage
        localStorage.setItem(`topUpCashTeamLeaders`, JSON.stringify(updatedList));
    };

    const handleDeleteItem = (teamLeaderID) => {
        const storedData = JSON.parse(localStorage.getItem(`topUpItemTeamLeaders`)) || [];

        // Filter out the voter to delete
        const updatedList = storedData.filter(item => item.id !== teamLeaderID);

        // Update the total amount
        const newTotal = updatedList.reduce((sum, item) => sum + parseInt(item.amount), 0);

        // Update state
        setTopUpItemTeamLeaders(updatedList);
        setTotalItems(newTotal);

        // Save updated list back to local storage
        localStorage.setItem(`topUpItemTeamLeaders`, JSON.stringify(updatedList));
    };

    const handleSearchVoter = () => {
        if (!searchName){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a District Coordinator Name'
            });
            return;
        } else if(searchName == ""){
            notification.error({
                top: 120,
                message: 'Error!',
                description: 'Please provide a District Coordinator Name'
            });
            return;
        } else{
            userStore.searchTeamLeader(searchName);
        }
    };

    const handlePrevPage = () => {
        userStore.page = userStore.page - 1;
        if(searchName){
            userStore.searchTeamLeader(searchName);
        }else{
            userStore.fetchUsersTeamLeaders(userType);
        }
        
    };

    const handleNextPage = () => {
        userStore.page = userStore.page + 1;
        if(searchName){
            userStore.searchTeamLeader(searchName);
        }else{
            userStore.fetchUsersTeamLeaders(userType);
        }
    };

    const handleTopupTeamLeaders = () => {
        const storedCashData = JSON.parse(localStorage.getItem("topUpCashTeamLeaders")) || [];
        const storedItemData = JSON.parse(localStorage.getItem("topUpItemTeamLeaders")) || [];

        if (storedCashData.length === 0 && storedItemData.length === 0) {
            notification.error({
                top: 120,
                message: 'Top Up Error',
                description: 'No District Coordinator selected for Top Up amount.'
            });
            return;
        }
    
        const transformedCashData = storedCashData.map((item) => ({
            userID: item.UserID,
            amount: item.amount,
            itemName: "NA", // AlWAYS "NA" IF TYPE OF DISTRIBUTION IS CASH
            description: "NA", // AlWAYS "NA" IF TYPE OF DISTRIBUTION IS CASH
            pricePerUnit: 0, // AlWAYS "0" IF TYPE OF DISTRIBUTION IS CASH
            quantity: 0, // AlWAYS "0" IF TYPE OF DISTRIBUTION IS CASH
            type: 'CASH',
            status: 'DONE'
        }));
    
        const transformedItemData = storedItemData.map((item) => ({
            userID: item.UserID,
            amount: item.amount,
            itemName: item.itemName,
            description: item.description,
            pricePerUnit: item.pricePerUnit,
            quantity: item.quantity,
            type: 'ITEM',
            status: 'PENDING'
        }));
    
        const transformedData = [...transformedCashData, ...transformedItemData];

        userStore.topupTeamLeaders(transformedData);
    };
    
    
    return (
        <div className="admin-add-team-leader">
            <Content>
                <div className="admin-add-team-leader-content">
                    <Title level={5}><SearchOutlined /> Search User</Title>
                    <Row gutter={10}>
                        <Col>
                            <Input
                                placeholder="Enter name"
                                allowClear
                                value={searchName}
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </Col>
                        <Col>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearchVoter}>Search User</Button>
                        </Col>
                    </Row>
                    <Divider/>
                    <Table pagination={false} columns={columns} dataSource={cloneDeep(userStore.teamLeaders)} bordered/>
                    <ul className="pagination">
                        <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={userStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                        <li className="pagination-item"><a>{userStore.page}</a></li>
                        <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={userStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                    </ul>
                </div>
            </Content>
            <Content>
                <Modal 
                    title="District Coordinator Fund Allocation" 
                    open={isOpenForm} 
                    onOk={() => {
                        form.submit()
                        setIsOpenForm(false)
                    }}
                    onCancel={() => {
                        setIsOpenForm(false);
                        setSelectedTeamLeader(null); // Reset the selected team leader
                        setDistributionType(null); // Reset distribution type
                        form.resetFields(); // Clear form fields
                    }}
                >
                    <Form
                        name="addbillingInformationForm"
                        layout="vertical"
                        form={form} 
                        onFinish={onFinish}
                        onValuesChange={(changedValues, allValues) => {
                            if (distributionType === "item") {
                                const { pricePerUnit, quantity } = allValues;
                                if (pricePerUnit && quantity) {
                                    const amount = pricePerUnit * quantity;
                                    form.setFieldsValue({ amount });
                                }
                            }
                        }}

                    >

                        <Form.Item 
                            label="Distribution Type" 
                            name="distributionType"
                            rules={[{ required: true, message: 'Please select a payment type.' }]}
                        >
                            <Select onChange={(value) => setDistributionType(value)} placeholder="Please Select Type of Distribution">
                                <Select.Option value="cash">Cash</Select.Option>
                                <Select.Option value="item">Item</Select.Option>
                            </Select>
                        </Form.Item>
                        

                        {distributionType === "cash" && (
                            <Form.Item 
                                label="Amount" 
                                name="amount"
                                rules={[{ required: true, message: 'Please input the amount.' }]}
                            >
                                <InputNumber placeholder="Enter Amount" style={{ width: "100%" }} />
                            </Form.Item>
                        )}

                        {distributionType === "item" && (
                            <>
                                <Form.Item 
                                    label="Item Name" 
                                    name="itemName"
                                    rules={[{ required: true, message: 'Please input Item Name.' }]}
                                >
                                    <Input placeholder="Enter Item Name" />
                                </Form.Item>
                                <Form.Item 
                                    label="Description" 
                                    name="description"
                                    rules={[{ required: true, message: 'Please input the description.' }]}
                                >
                                    <Input placeholder="Enter Description" />
                                </Form.Item>
                                <Form.Item 
                                    label="Price per Unit" 
                                    name="pricePerUnit"
                                    rules={[{ required: true, message: 'Please input the price per unit.' }]}
                                >
                                    <InputNumber placeholder="Enter Price" style={{ width: "100%" }} />
                                </Form.Item>
                                <Form.Item 
                                    label="Quantity" 
                                    name="quantity"
                                    rules={[{ required: true, message: 'Please input the quantity.' }]}
                                >
                                    <InputNumber placeholder="Enter Quantity" style={{ width: "100%" }} />
                                </Form.Item>
                                <Form.Item 
                                    label="Amount" 
                                    name="amount"
                                    rules={[{ required: true, message: 'Please input the amount.' }]}
                                >
                                    <InputNumber placeholder="Enter Amount" style={{ width: "100%" }} />
                                </Form.Item>
                            </>
                        )}

                    </Form>
                </Modal>
                <div className="admin-add-team-leader-content">
                    <Title level={4}>List of Distributed Cash</Title>
                    <Table columns={columnsTopUpCash} dataSource={topUpCashTeamLeaders} bordered/>
                    <Title level={4}>List of Distributed Items</Title>
                    <Table columns={columnsTopUpItems} dataSource={topUpItemTeamLeaders} bordered/>
                    <Row justify={'end'}>
                        <Space>
                            <Title level={4} strong>Total Top Up Amount: </Title><Title level={4} strong type="danger">₱ {formatNumber(totalCash+totalItems)}</Title>
                        </Space>
                    </Row>
                    <Divider/>
                    <Row justify={'end'} gutter={12}>
                        <Col>
                            <Button type="primary" htmlType="submit" icon={<PlusOutlined/>} loading={userStore.loading} onClick={handleTopupTeamLeaders}>Submit</Button>
                        </Col>
                        <Col>
                            <Button onClick={() => navigate(-1)} loading={userStore.loading}>Back</Button>
                        </Col>
                    </Row>
                </div>
            </Content>
        </div>
    );
};

export default inject('userStore')(observer(TopUpTeamLeaders));
